import { Flex, Image, Spacer } from "@chakra-ui/react";
import MenuItem from "./MenuItem";
import { FC } from "react";
import {
  BsAward,
  BsBarChartSteps,
  BsDiagram3,
  BsFileBarGraph,
  BsFileEarmark,
  BsFolder2Open,
  BsGeoAlt,
  BsHouseDoor,
  BsLayoutThreeColumns,
  BsPeople,
} from "react-icons/bs";
import MenuGroupComponent from "./MenuGroupComponent";
import { useAuth } from "../../../provider/AuthProvider";

const Menu: FC = () => {
  const { auth } = useAuth();
  const user = auth.user;

  const hasAnyPermission = (permissions: string[]) =>
    permissions.some((permission) => user.permissions.includes(permission));

  return (
    <Flex flexDirection="column" w="174px" gap={2}>
      <Flex justifyContent="center" py={9} px={2}>
        <Image
          src="/images/logo.svg"
          alt="Sistema de Informação e Alerta Rápido para a Segurança Alimentar e Nutricional"
        />
      </Flex>
      <Flex direction="column" width="174px" alignItems="center" gap={6}>
        <Flex flexDirection="column" w="100%">
          <Flex flexDirection="column" pt={4}>
            <MenuItem
              title="Painel de Controlo"
              link="/dashboard"
              icon={<BsHouseDoor color="#000" />}
            />
            <MenuItem
              title="Indicadores"
              link="/indicadores"
              icon={<BsFileBarGraph color="#000" />}
            />
            <MenuItem
              title="Documentos"
              link="/documentos"
              icon={<BsFolder2Open color="#000" />}
            />
          </Flex>
        </Flex>
        {hasAnyPermission(["GetBulletin", "GetOccurrences"]) && (
          <MenuGroupComponent name="Resultados">
            {user.permissions.includes("GetBulletin") && (
              <MenuItem
                title="Boletins"
                link="/boletins"
                icon={<BsFileEarmark color="#000" />}
              />
            )}
            {user.permissions.includes("GetOccurrences") && (
              <MenuItem
                title="Ocorrências no Terreno"
                link="/ocorrencias-no-terreno"
                icon={<BsGeoAlt color="#000" />}
              />
            )}
          </MenuGroupComponent>
        )}
        {hasAnyPermission([
          "GetIndicators",
          "GetUser",
          "GetRoles",
          "GetOrganizations",
          "ManageLookups",
        ]) && (
          <MenuGroupComponent name="ADMINISTRAÇÃO">
            {user.permissions.includes("GetIndicators") && (
              <MenuItem
                title="Gestão de indicadores"
                link="/gestao-de-indicadores"
                icon={<BsBarChartSteps color="#000" />}
              />
            )}
            {user.permissions.includes("GetUser") && (
              <MenuItem
                title="Utilizadores"
                link="/utilizadores"
                icon={<BsPeople color="#000" />}
              />
            )}
            {user.permissions.includes("GetRoles") && (
              <MenuItem
                title="Perfis"
                link="/perfis"
                icon={<BsAward color="#000" />}
              />
            )}
            {user.permissions.includes("GetOrganizations") && (
              <MenuItem
                title="Entidades"
                link="/entidades"
                icon={<BsDiagram3 color="#000" />}
              />
            )}
            {user.permissions.includes("ManageLookups") && (
              <MenuItem
                title="Tabelas Auxiliares"
                link="/tabelas-auxiliares"
                icon={<BsLayoutThreeColumns color="#000" />}
              />
            )}
          </MenuGroupComponent>
        )}
        <Spacer />
      </Flex>
    </Flex>
  );
};

export default Menu;
